// TODO: Utilizar moment para formatear horas, reemplazar dayjs por moment ya que no funciona correctamente.

import moment from 'moment';

/**
 *
 * @param {String}
 * @returns {String}
 */
export function formatTime(time, endTime, format = 'HH:mm:ss') {
  if (!time) return '';
  const formattedTime = moment(time, format).format('hh:mm A');
  if (endTime) {
    const formattedEndTime = moment(endTime, format).format('hh:mm A');
    return `${formattedTime} - ${formattedEndTime}`;
  }
  return formattedTime;
}
